import { render } from "./ArticleReader.vue?vue&type=template&id=af84b384&scoped=true"
import script from "./ArticleReader.vue?vue&type=script&lang=js"
export * from "./ArticleReader.vue?vue&type=script&lang=js"

import "./ArticleReader.vue?vue&type=style&index=0&id=af84b384&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af84b384"]])

export default __exports__